import {
  StaffActivitiesByDescription,
  StaffActivityDetails,
} from "../../types";

const WI_STATE_PORTAL_BASE: StaffActivityDetails = {
  parameters: {
    linkUrls: ["https://whoprs.wisconsin.gov/Account/Login.aspx"],
    staffInputs: {
      documentTypes: {
        report: true,
      },
    },
  },
  jurisdictionType: "State",
  activityType: "Portal",
  state: "WI",
};

export const staffActivities: StaffActivitiesByDescription = {
  "Wisconsin State Portal": {
    ...WI_STATE_PORTAL_BASE,
    parameters: {
      ...WI_STATE_PORTAL_BASE.parameters,
      staffInputs: {
        ...WI_STATE_PORTAL_BASE.parameters.staffInputs,
        fees: true,
        documentTypes: {
          ...WI_STATE_PORTAL_BASE.parameters.staffInputs?.documentTypes,
          invoice: true,
          receipt: true,
        },
      },
    },
  },
  "Wisconsin State Portal - Revision": {
    ...WI_STATE_PORTAL_BASE,
    parameters: {
      ...WI_STATE_PORTAL_BASE.parameters,
      staffInputs: {
        ...WI_STATE_PORTAL_BASE.parameters.staffInputs,
        fees: false,
      },
    },
  },
};
